import * as React from "react"
import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg" | "xl"
  variant?: "default" | "primary" | "secondary" | "muted"
}

const sizeClasses = {
  sm: "h-4 w-4",
  default: "h-8 w-8",
  lg: "h-12 w-12",
  xl: "h-24 w-24",
}

const variantClasses = {
  default: "text-foreground",
  primary: "text-primary",
  secondary: "text-secondary-foreground",
  muted: "text-muted-foreground",
}

function Spinner({
  className,
  size = "default",
  variant = "primary",
  ...props
}: Readonly<SpinnerProps>) {
  return (
    <div
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn("flex items-center justify-center", className)}
      {...props}
    >
      <Loader2
        className={cn(
          "animate-spin",
          sizeClasses[size],
          variantClasses[variant]
        )}
      />
      <span className="sr-only">Loading...</span>
    </div>
  )
}

function FullPageSpinner({
  className,
  size = "xl",
  variant = "primary",
  ...props
}: Readonly<SpinnerProps>) {
  return (
    <div
      data-slot="full-page-spinner"
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm",
        className
      )}
      {...props}
    >
      <Spinner size={size} variant={variant} />
    </div>
  )
}

export { Spinner, FullPageSpinner }
